// Generated types for EntityExtractionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { LLMTaskReadAPI, LLMTaskWriteAPI } from '../../llm_task/types/llmtask';
import { LLMTaskReadAPISchemaObject, LLMTaskWriteAPISchemaObject } from '../../llm_task/types/llmtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface EntityExtractionTaskReadAPI extends LLMTaskReadAPI {
}

export interface EntityExtractionTaskWriteAPI extends LLMTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const EntityExtractionTaskReadAPISchemaObject = LLMTaskReadAPISchemaObject.extend({}).passthrough();
export const EntityExtractionTaskReadAPISchema: z.ZodType<EntityExtractionTaskReadAPI> = EntityExtractionTaskReadAPISchemaObject;

export const EntityExtractionTaskWriteAPISchemaObject = LLMTaskWriteAPISchemaObject.extend({}).passthrough();
export const EntityExtractionTaskWriteAPISchema: z.ZodType<EntityExtractionTaskWriteAPI> = EntityExtractionTaskWriteAPISchemaObject;
